!function() {
    "use strict";
    function t(t, i, e) {
        return i in t ? Object.defineProperty(t, i, {
            value: e,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : t[i] = e,
        t
    }
    var i = () => class extends GP.Component {
        connectedCallback() {
            let t = this.closest("gp-product");
            if ((null == t ? void 0 : t.getState) && t.getState("isReady")) {
                this.rootInit();
                return
            }
            null == t || t.addEventListener("gp:product-init", () => {
                requestAnimationFrame( () => {
                    this.context = null == t ? void 0 : t.context,
                    this.rootInit()
                }
                )
            }
            )
        }
        constructor(i) {
            super(),
            t(this, "initFunc", void 0),
            t(this, "rootInit", () => {
                let t = this.closest(".gps > section");
                if (null == t ? void 0 : t.classList.contains("gps-lazy")) {
                    null == t || t.addEventListener("GpLazyLoaded", this.rootInit);
                    return
                }
                null == t || t.removeEventListener("GpLazyLoaded", this.rootInit),
                this.initFunc && this.initFunc()
            }
            ),
            this.initFunc = i
        }
    }
    ;
    function e(t, i, e) {
        return i in t ? Object.defineProperty(t, i, {
            value: e,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : t[i] = e,
        t
    }
    let n = () => {
        window.removeEventListener("gp-global-loaded", n);
        class t extends i() {
            constructor() {
                var t;
                super( () => {
                    this.init()
                }
                ),
                e(this, "productTitleLink", null),
                e(this, "hrefOriginal", void 0),
                e(this, "isEnableLink", !1),
                e(this, "updateHrefWithVariant", t => {
                    this.productTitleLink && this.isEnableLink && t && this.productTitleLink.setAttribute("href", `${this.hrefOriginal}?variant=${t}`)
                }
                ),
                e(this, "init", () => {
                    let t = this.getState("setting");
                    this.isEnableLink = (null == t ? void 0 : t.linkProduct) == !0;
                    let i = !1 !== this.getContext("hasPreSelected")
                      , e = this.getContext("variantSelected");
                    i && this.updateHrefWithVariant((null == e ? void 0 : e.id) != null ? String(e.id) : void 0),
                    this.subscribeContext( (t, i) => {
                        var e, n, l;
                        this.isEnableLink && (null == t ? void 0 : null === (e = t.variantSelected) || void 0 === e ? void 0 : e.id) !== (null == i ? void 0 : null === (n = i.variantSelected) || void 0 === n ? void 0 : n.id) && (null === (l = t.variantSelected) || void 0 === l ? void 0 : l.id) && this.updateHrefWithVariant(String(t.variantSelected.id))
                    }
                    )
                }
                ),
                this.productTitleLink = this.querySelector(".gp-product-title-link-wrapper"),
                this.hrefOriginal = (null === (t = this.productTitleLink) || void 0 === t ? void 0 : t.getAttribute("href")) || ""
            }
        }
        customElements.get("gp-product-title") || customElements.define("gp-product-title", t)
    }
    ;
    "completed" === window.gpReadyState ? n() : window.addEventListener("gp-global-loaded", n)
}();
